'use strict';

module.exports = require('./lib/React');



/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/motion/js-deps/~/react/react.js
 ** module id = 1
 ** module chunks = 0
 **/